import { useMemo, useCallback } from 'react';
import { useCustomerAuth, useSettings } from '@backpackjs/storefront';

export const useCustomerTagFiltering = () => {
  const settings = useSettings();
  const collectionSettings = settings?.collection || {};
  const { filterByCustomerTags = '' } = collectionSettings || {};
  const { customer, customerInit } = useCustomerAuth();

  const customerFilterTags = useMemo(() => {
    return filterByCustomerTags?.split(',').map((tag) => tag.trim()) || [];
  }, [filterByCustomerTags]);

  const customerTags = useMemo(() => {
    return (customer?.tags || []).filter((tag) =>
      customerFilterTags?.includes(tag)
    );
  }, [customer?.tags, customerFilterTags]);

  const filterProducts = useCallback(
    (products = []) => {
      if (!customerInit) return null;
      if (!products?.length || !customerFilterTags?.length) {
        return products || null;
      }

      return products.filter((product) => {
        if (!product?.tags?.length) return true;
        const hasFilterTag = product?.tags?.find((tag) =>
          customerFilterTags?.includes(tag)
        );
        if (
          customerInit &&
          hasFilterTag &&
          !product?.tags?.find((tag) => customerTags?.includes(tag))
        ) {
          return false;
        }
        return true;
      });
    },
    [customerFilterTags, customerTags, customerInit]
  );

  return {
    customerFilterTags,
    customerTags,
    filterProducts,
  };
};
